import React from "react";
import upload from "../../assets/icons/Upload.svg";
import download from "../../assets/icons/download.svg";
import { timestampToPersianDate } from "../../utils/function.utils";

const TransactionsCard = ({ data }) => {
  return (
    <li
      className={
        "bg-[#F6F6F6] border-2 border-[#E7E7E7] rounded-[8px] px-1 py-2 flex items-center justify-between"
      }
    >
      <section className={"flex items-center gap-1"}>
        <div>
          {data?.type === "deposit" ? (
            <img src={download} className="w-5 h-5" alt={"icon"} />
          ) : (
            <img src={upload} className="w-5 h-5" alt={"icon"} />
          )}
        </div>
        <span className={"text-[12px] mt-0.5 text-dark-400 font-medium"}>
          {timestampToPersianDate(data?.created_at * 1000)}
        </span>
      </section>
      <section
        className={
          "flex items-center gap-1 text-[12px] text-dark-400 font-medium"
        }
      >
        {data?.type === "deposit" ? (
          <span>{Number(data?.amount).toLocaleString()}</span>
        ) : (
          <span>{Number(-1 * data?.amount).toLocaleString()}</span>
        )}
        <span>تومان</span>
      </section>
      <section className={"flex items-center gap-2 text-[12px]"}>
        {data?.type === "deposit" ? (
          <span className={"font-medium text-[#34C759]"}>واریز</span>
        ) : (
          <span className={"font-medium text-[#FD631C]"}>برداشت</span>
        )}
        <i className="fa fa-chevron-left text-[15px] text-stone-600" />
      </section>
    </li>
  );
};

export default TransactionsCard;
